import React from 'react';
import Link from 'next/link';
import styled, { css } from 'styled-components';

import { Button, useMediaQuery, Container } from '@material-ui/core';

import { BREAKPOINTS } from 'src/utils/constants';
import { IListings } from 'src/interface';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { useAuthentication } from 'src/contexts/auth/auth.context';
import Card from '../ListingCard';
import FiltersSection from './filters';
import EmptyBoxAnimation from '../Common/lottie/EmptyBox';
import RentableAd from '../Common/lottie/RentableAd';

import RentNowCard from '../ListingCard/RentNowCard';
import { StyledGrid } from '../LandingPage/Components/ListingsSection';
import TipsCard from '../ListingCard/TipsCard';
import ListingsAdBanner from '../Adsense/ListingsAd';

type IStyledProps = {
  isMobile?: boolean;
};
const TitleSection = styled('div')<IStyledProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const Content = styled('div')<IStyledProps>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile && 'column-reverse') || 'row'};
  justify-content: ${({ isMobile }) => (isMobile && 'center') || 'flex-start'};
  align-items: ${({ isMobile }) => (isMobile && 'stretch') || 'flex-start'};
`;
const Filters = styled('div')`
  display: flex;
  flex-direction: column;
  flex-basis: 25%;
  min-width: 25%;
`;
const ListingsContainer = styled('div')<IStyledProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: ${({ isMobile }) => (isMobile && '40px 0') || '0px 20px 30px'};
`;
// const ListingsContent = styled('div')`
//   display: flex;
//   flex-wrap: wrap;
//   align-items: flex-start;
// `;
export const desktopCard = css`
  //max-width: 240px;
  //width: 240px;
  //margin: 10px;
`;
export const mobileCard = css`
  width: 100%;
`;
export const StyledListingCard = styled(Card)<IStyledProps>`
  ${({ isMobile }) => (isMobile && mobileCard) || desktopCard};
`;
const ViewMore = styled(Button)`
  margin: 20px 0 !important;
  padding: 10px 20px !important;
  align-self: center;
`;
const AdContainer = styled.div<IStyledProps>`
  max-width: 100%;
  margin: ${({ isMobile }) => (isMobile && '50px 0') || '40px 0'};
`;

type Props = {
  Listings: IListings | null;
  canLoadMore: boolean;
  isLoading: boolean;
  setViewItems: React.Dispatch<any>;
  isWantedSearch?: boolean;
};

const SearchPage = ({ Listings, canLoadMore, isLoading, setViewItems, isWantedSearch }: Props) => {
  const [authState, dispatchToAuth] = useAuthentication();
  const { isAuthenticated } = authState;
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
  return (
    <Container maxWidth="lg">
      <TitleSection>
        <h1>Search</h1>
        <p>{Listings?.data.length || 0} results found</p>
      </TitleSection>
      <Content isMobile={isMobile}>
        <Filters>
          <FiltersSection isWantedSearch={isWantedSearch || false} />
          <AdContainer isMobile={isMobile}>
            <Link href="/post-listing" passHref>
              <a href="/post-listing">
                <RentableAd width={300} height={300} />
              </a>
            </Link>
          </AdContainer>
        </Filters>
        <ListingsContainer isMobile={isMobile}>
          <Grid container xs={12} spacing={2} direction="row">
            {(Listings &&
              Listings?.data.length &&
              Listings.data.map((listing, key) => {
                if (key % 10 === 0 && key !== 0) {
                  return (
                    <>
                      <StyledGrid key={key} item xs={12} sm={4}>
                        {key % 20 === 0 ? (
                          (isAuthenticated && (
                            <Link href="/post-listing">
                              <a href="/post-listing">
                                <Box style={{ height: '100%' }}>
                                  <TipsCard>
                                    <Button variant="contained" color="secondary">
                                      Start Renting
                                    </Button>
                                  </TipsCard>
                                </Box>
                              </a>
                            </Link>
                          )) || (
                            <Box style={{ height: '100%' }}>
                              <RentNowCard>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={() =>
                                    dispatchToAuth({ type: 'SWITCH_AUTH_MODAL', payload: true })
                                  }
                                >
                                  Start Renting
                                </Button>
                              </RentNowCard>
                            </Box>
                          )
                        ) : (
                          <Box style={{ height: '100%', maxHeight: '390px', overflow: 'hidden' }}>
                            <ListingsAdBanner />
                          </Box>
                        )}
                      </StyledGrid>
                      <Grid key={key} item xs={12} sm={4}>
                        <Box>
                          <StyledListingCard
                            key={listing.id}
                            listingData={listing}
                            isMobile={isMobile}
                          />
                        </Box>
                      </Grid>
                    </>
                  );
                }
                return (
                  <Grid key={key} item xs={12} sm={4}>
                    <Box>
                      <StyledListingCard
                        key={listing.id}
                        listingData={listing}
                        isMobile={isMobile}
                      />
                    </Box>
                  </Grid>
                );
              })) || (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  alignSelf: 'center',
                }}
              >
                <EmptyBoxAnimation width={200} height={200} />
                No Results found
              </div>
            )}
          </Grid>
          {canLoadMore && (
            <ViewMore
              color="primary"
              disabled={isLoading}
              onClick={() => setViewItems((m: number) => m + 8)}
              variant="contained"
            >
              {(isLoading && '...Loading') || 'View more'}
            </ViewMore>
          )}
        </ListingsContainer>
      </Content>
    </Container>
  );
};

export default SearchPage;
